import { Radio } from "antd";
import ICustomRadioProps from "components/CustomRadio/ICustomRadioProps";

import "./CustomRadio.css";

const CustomRadio: React.FC<ICustomRadioProps> = ({ text, value, autoFocus }) => {
	return (
		// eslint-disable-next-line jsx-a11y/no-autofocus
		<Radio className="custom-radio" value={value} tabIndex={0}>
			<span className="radio-text">{text}</span>
		</Radio>
	);
};

export default CustomRadio;
